export enum example {
  example = "example",
}
export enum ColorsEnum {
  Primary = "primary",
  Secondary = "secondary",
  Danger = "danger",
  Success = "success",
  Warning = "warning",
  Accent = "accent",
  Muted = "muted",
  White = "white",
}

export enum LanguagesEnum {
  EN = "en",
  AR = "ar",
}
export enum SizesEnum {
  Small = "sm",
  Medium = "md",
  Large = "lg",
}
export enum InputStylesEnum {
  STYLE1 = "style1",
  STYLE2 = "style2",
  STYLE3 = "style3",
  STYLE4 = "style4",
}

export enum DirectionEnum {
  RTL = "rtl",
  LTR = "ltr",
}
export enum MenuStatusEnum {
  Default = "default",
  Hover = "hover",
  Selected = "selected",
  SelectedAndHover = "selectedAndHover",
  Disabled = "disabled",
}

export enum MenuTypeEnum {
  Label = "label",
  Option = "option",
  ActionBar = "actionBar",
}
export enum OptionLevelEnum {
  One = "one",
  Two = "two",
  Three = "three",
  Four = "four",
  Five = "five",
}
  
  
export enum ButtonStyleEnum{
  Filled = "filled",
  OutlineStyleOne = "outlineStyleOne",
  OutlineStyleTow = "outlineStyleTow",
  Muted= "muted",
  Disabled="disabled"

}
export enum SizesButtonEnum {
  Small = 'w-24 h-8 text-xs',
  Medium = 'w-28 h-10 text-sm px-4 ',
  Large = 'w-36 h-12 text-lg px-4',
}
export enum BorderRadiusEnum {
  Small = 'rounded-sm',
  Medium = 'rounded-md',
  Large = 'rounded-lg',
}

